import * as ErrorModal from './components/ErrorModal/ErrorModal.css';

export default {
	ErrorModal
};
